import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import {
  faEnvelope,
  faSignInAlt,
  faSignOutAlt,
  faTachometerAlt,
  faUser,
  faUserPlus,
} from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '@services/auth/auth.service';
import { ScrollTop, ScrollTopFn } from '@app/shared/navigation-bar/scroll-top.token';
import { LayoutService } from '@app/services/settings/layout.service';
import { CanViewDirective } from '../../../directives/can-view.directive';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { afterNextRender } from '@angular/core';
import { HeaderData } from '@app/services/settings/models/settings-response';
import { MenuItem } from '../menu-items';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive, NgbTooltip, FontAwesomeModule, CanViewDirective],
})
export class NavigationBarComponent {
  readonly auth = inject(AuthService);
  readonly scrollTop = inject<ScrollTopFn>(ScrollTop);
  readonly layout = inject(LayoutService);
  
  loginIcon = faSignInAlt;
  logoutIcon = faSignOutAlt;
  signUpIcon = faUserPlus;
  dashboardIcon = faTachometerAlt;
  newsletter = faEnvelope;
  userIcon = faUser;
  showNavigation: boolean = false;

  headerData = input.required<HeaderData>();
  showProposals = input.required<boolean>();
  parsedMenu = input.required<MenuItem[]>();
  externalLink = input<string>();

  constructor() {
    afterNextRender(() => (this.showNavigation = true));
  }
}
